export default {
    index: {
        listagem_setores: 'Sector Listing',
        setor_nao_encontrado: 'No sector found',
        criar_setor: 'Create Sector',
        editar: 'Edit',
        nome: 'Name',
        apelido: 'Nickname'
    },
    form: {
        setores: 'Sectors',
        unidade_atendimento_principal: 'Main Service Unit',
        informacoes: 'Information',
        nome: 'Name',
        nome_descricao: 'Sector Name',
        mnemonico: 'Mnemonic',
        mnemonico_descricao: 'Sector Mnemonic',
        veus_id_descricao: 'Sector ID in Veus Saúde',
        vinculo: 'Link',
        unidade_atendimento_principal_descricao: 'Main Service Unit',
        setor_criado_sucesso: 'Sector successfully created!',
        setor_atualizado_sucesso: 'Sector successfully updated!'
    }    
}